import { Checkbox, Grid, Typography } from '@mui/material'
import React, { ChangeEvent } from 'react'

interface AuthorizationGroupParams {
  interminate: boolean
  checked: boolean
  title: string
  total: number
  selected: number
  onChangeAll: (event: ChangeEvent<HTMLInputElement>) => void
}

const AuthorizationGroup: React.FC<AuthorizationGroupParams> = ({
  interminate,
  checked,
  title,
  total,
  selected,
  onChangeAll,
}) => {
  return (
    <Grid
      container
      spacing={1}
    >
      <Grid
        item
        xs={2}
        sx={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'flex-start',
        }}
      >
        <Checkbox
          sx={{
            mt: '-5px',
            '&.Mui-disabled': {
              opacity: '0.08',
            },
          }}
          color='primary'
          checked={checked}
          indeterminate={interminate}
          onChange={onChangeAll}
        />
      </Grid>

      <Grid
        item
        xs={8}
        sx={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'flex-start',
          mt: '-5px',
        }}
      >
        <Typography
          sx={{
            fontSize: '14.5px',
            lineHeight: '19px',
            fontWeight: '400',
            mt: '-5px',
          }}
        >
          {title}
        </Typography>
      </Grid>

      <Grid
        item
        xs={2}
        sx={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'flex-end',
          mt: '-5px',
        }}
      >
        <Typography
          sx={{
            fontSize: '12px',
            lineHeight: '20px',
            fontWeight: '600',
            mt: '-5px',
            mr: '2px',
          }}
        >
          {selected}/{total}
        </Typography>
      </Grid>
    </Grid>
  )
}

export default AuthorizationGroup
